<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 24 24"
  fill="none"
  focusable="false"
  aria-hidden="true"
>
  <path
    d="M14.9766 7.11523C15.1221 7.40817 15.402 7.61116 15.7256 7.65918L22.3438 8.63867L17.5654 13.3213C17.3317 13.5503 17.2249 13.8795 17.2793 14.2021L18.3926 20.7988L12.4629 17.7021C12.1728 17.5506 11.8272 17.5506 11.5371 17.7021L5.60742 20.7988L6.7207 14.2021C6.7751 13.8795 6.66826 13.5503 6.43457 13.3213L1.65625 8.63867L8.27441 7.65918C8.59796 7.61116 8.87788 7.40817 9.02344 7.11523L12 1.12402L14.9766 7.11523Z"
    [attr.stroke]="fillColor"
  />
</svg>
